@if (widget) {
  <div class="clickable withOpacity w-100 mobile-correction" (click)="gotoUrl()">
    <img class="img-thumbnail p-0 border-0 w-100" draggable="false" [src]="widget.language_definitions[0].image_url">
    @if (!hideLabel) {
      <p [innerHTML]="widget.language_definitions[0].title" class="m-0 py-2 px-3 w-100 fw-bold"></p>
    }
  </div>
}
